// Safari < 14 (iOS 13, macOS 10.15 and older) only has addListener/removeListener
// on MediaQueryList, while MUI's useMediaQuery calls addEventListener("change").
// myFoncia clients still browse on those versions.
export function polyfillMediaQueryListListeners(): void {
  if (typeof MediaQueryList === "undefined") {
    return;
  }

  const prototype: LegacyMediaQueryList = MediaQueryList.prototype;
  if (prototype.addEventListener) {
    return;
  }

  Object.defineProperties(MediaQueryList.prototype, {
    addEventListener: {
      configurable: true,
      writable: true,
      value: function addEventListener(
        this: MediaQueryList,
        type: string,
        listener: EventListenerOrEventListenerObject | null,
      ) {
        if (type === "change" && typeof listener === "function") {
          this.addListener(listener);
        }
      },
    },
    removeEventListener: {
      configurable: true,
      writable: true,
      value: function removeEventListener(
        this: MediaQueryList,
        type: string,
        listener: EventListenerOrEventListenerObject | null,
      ) {
        if (type === "change" && typeof listener === "function") {
          this.removeListener(listener);
        }
      },
    },
  });
}

type LegacyMediaQueryList = Pick<
  MediaQueryList,
  "addListener" | "removeListener"
> &
  Partial<Pick<MediaQueryList, "addEventListener" | "removeEventListener">>;
